import React from 'react';
import EkonomiskAnalysEditColumnAutosuggest from './EkonomiskAnalysEditColumnAutosuggest';
import EkonomiskAnalysBudgetQuery from '../Queries/EkonomiskAnalysBudgetQuery/EkonomiskAnalysBudgetQuery';
import { createBudgetSuggestions } from './Utils/EkonomiskAnalysEditColumnSuggestionUtils';
import { BudgetTypes } from '../EkonomiskAnalysEditColumnForm';
import Field from '../../../../../../../../../../../../BaseComponents/Forms/EDField';
import { showBudgetSuggestField } from '../../Utils/EkonomiskAnalysEditColumnUtils';

interface IProps {
  hidden: boolean;
  budgetType: BudgetTypes | null;
}

class EkonomiskAnalysEditColumnBudgetField extends React.Component<IProps> {
  render() {
    const isKategori = this.props.budgetType === BudgetTypes.category;
    const fieldName = 'budget';
    return (
      <Field name={fieldName}>
        {({ value, onChange, onBlur, touched, fieldErrors }) => (
          <EkonomiskAnalysBudgetQuery>
            {({ budgetList }) => (
              <EkonomiskAnalysEditColumnAutosuggest
                label={isKategori ? 'Välj kategori' : 'Välj specifik budget'}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                touched={touched}
                fieldErrors={fieldErrors}
                suggestions={
                  budgetList != null
                    ? createBudgetSuggestions(isKategori, budgetList)
                    : []
                }
                hidden={!showBudgetSuggestField(this.props.budgetType)}
              />
            )}
          </EkonomiskAnalysBudgetQuery>
        )}
      </Field>
    );
  }
}

export default EkonomiskAnalysEditColumnBudgetField;
